import React, { useMemo } from 'react';
import { useGetCompaniesInfinite } from '@area-restrita/api-client/endpoints/companies/companies.gen';

import DataTableFacetedFilter, {
  IDataTableFacetedFilterProps,
} from '../DataTable/DataTableFacetedFilter';

type IProps = Omit<IDataTableFacetedFilterProps<any, any>, 'options'>;

const CompanyQueryFilter: React.FC<IProps> = (props) => {
  const query = useGetCompaniesInfinite(
    { limit: 1000, page: 1 },
    {
      query: {
        queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const companies = useMemo(
    () =>
      query.data?.pages.flatMap((page) =>
        page.data.map((company) => ({
          label: company.tradingName,
          value: company.id,
        })),
      ) ?? [],
    [query.data],
  );

  return <DataTableFacetedFilter options={companies} {...props} />;
};

export default CompanyQueryFilter;
